module.exports = function() {
  return new Worker(__webpack_public_path__ + "6caf37a5514386b4db20.worker.js");
};